import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: any;
  data?: any;
};

export interface SelectProps {
  options: Option[];
  defaultValue?: Option;
  className?: string;
  styles?: any; 
  onChange? : (value:any) => void;
  disabled?: boolean | false
  formatOptionLabel?: (option: Option) => React.ReactNode;
}

const CommonSelect: React.FC<SelectProps> = ({ options, defaultValue, className, disabled, onChange, formatOptionLabel }) => {
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(defaultValue);

  const handleChange = (option: Option | null) => {
    setSelectedOption(option || undefined);
    if(onChange){
      onChange(option?.value)
    }
  };
  useEffect(() => {
    setSelectedOption(defaultValue || undefined);
  }, [defaultValue])
  
  return (
    <Select

      classNamePrefix="react-select"
      className={className}
      // styles={customStyles}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      placeholder="Select"
      isDisabled={disabled}
      formatOptionLabel={formatOptionLabel}
    />
  );
};

export default CommonSelect;
